document.addEventListener("DOMContentLoaded", () => {
    const selectReferralPartner = document.querySelector(".js-referral-partner"),
      linkReferralPartner = document.querySelector(".js-referral-partner-link");

    if(selectReferralPartner) {

        selectReferralPartner.addEventListener("change", (e) => {

            const partner_id = e.target.value;

            if(partner_id) {

                const __link = `/partners/${partner_id}/edit`;

                linkReferralPartner.href = __link;

            }


        })

    }
})